import React from "react";
import AppContainer from "../../../components/AppContainer";
import ExportButton from "../../../components/ExportButton";
import { allIcons } from "../../../assets";
import DynamicTable from "../../../components/DynamicTable";
import GlobalButton from "../../../components/CustomButton";
import { Stack, Typography } from "@mui/material";
import TableData from "../../../dumyData/AllTeamMembers.json";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import DeletingConfirmationDialog from "./DeletingConfirmationDialog";
import appcolors from "../../../constants/Colors";

const headerData = [
  "Details",
  "Address",
  "Designation",
  "Rating",
  "Status",
  "Actions",
];

const tableRows = [
  "person_detail",
  "address",
  "designation",
  "rating",
  "status",
  "actions",
];

function TeamMembers(props) {
  const {
    open,
    setOpen,
    handleEdit,
    confirmRef,
    setFormData,
    handleDelete,
    allTeamMembers,
    searchInput,
    setSearchInput,
    handleChangeTab,
    handleDeleteTeamMember,
    handleChangeStatus,
  } = props;

  // Redux states

  const handleNavigate = () => {};

  // Render right part on header
  const handleChangeSearchInput = (e) => {
    setSearchInput(e.target.value);
  };
  const renderRightPart = () => {
    return (
      <Stack
        gap={1}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        {/* <ExportButton handleClick={() => console.log("I am export")} /> */}
        <GlobalButton
          variant={"contained"}
          btnText={"Add New"}
          handleClickBtn={() => {
            setFormData((prev) => ({
              teamType: "add",
            }));
            handleChangeTab("addNewMember");
          }}
          styleProps={{
            fontWeight: 400,
            fontSize: "0.875rem",
            height: 40,
            width: 120,
          }}
        />
      </Stack>
    );
  };
  return (
    <AppContainer
      primaryHeading={"Team members"}
      secondaryHeading={"View, add, edit and delete your teams details."}
      headProps={renderRightPart()}
      onChange={handleChangeSearchInput}
      searchValue={searchInput}
      showSerach
    >
      {allTeamMembers?.length > 0 ? (
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allTeamMembers}
          // showDelete
          showEdit
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleNavigate={handleNavigate}
          handleChangeStatus={handleChangeStatus}
        />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
          mb={20}
        >
          No Team Member Found!
        </Typography>
      )}
      <DeletingConfirmationDialog
        open={open}
        ref={confirmRef}
        setOpen={setOpen}
        handleDeleteTeamMember={handleDeleteTeamMember}
      />
    </AppContainer>
  );
}

export default TeamMembers;
